import React from "react";
import Head from "./Head/Head";

const blog = () => {
  return (
    <>
      <Head />
      <div style={{padding:'10rem'}}>blog</div>
    </>
  );
};

export default blog;
